/**
 * Telemetry hook fired when a command-palette result is selected. The repo doesn't
 * currently have an analytics layer wired in the admin-dashboard, so this is a
 * stub that logs in dev and no-ops in prod. Swap the body for the real client
 * when one lands.
 *
 * TODO(phase-4+): replace console.debug with the project's analytics client
 * (e.g. a `trackEvent` helper from a shared analytics module).
 */
export interface CmdkSelectEvent {
  event: 'cmdk.select';
  type:
    | 'navigate'
    | 'clients'
    | 'contact'
    | 'subscription'
    | 'invoice'
    | 'action'
    | 'recent'
    | 'see-all';
  queryLength: number;
  openedInNewTab: boolean;
}

export function trackCmdkSelect(payload: Omit<CmdkSelectEvent, 'event'>): void {
  const full: CmdkSelectEvent = { event: 'cmdk.select', ...payload };
  if (import.meta.env.DEV) {
    console.debug('[telemetry]', full);
  }
}
